import { useRef, useState } from 'react'

export function useTimeoutState(): {
  state: boolean
  setState: (state: boolean, timeout?: number) => () => void
} {
  const [state, setState] = useState(false)
  const lastTypingHeartbeatRef = useRef<Date | null>(null)

  return {
    state: state,
    setState: (state: boolean, timeout?: number) => {
      setState(state)
      if (!state) {
        return () => {}
      }
      lastTypingHeartbeatRef.current = new Date()
      if (!timeout) {
        return () => {}
      }
      const timeoutId = setTimeout(() => {
        const lastHeartbeat = lastTypingHeartbeatRef.current
        if (lastHeartbeat && new Date().getTime() - lastHeartbeat.getTime() > timeout) {
          setState(false)
        }
      }, timeout + 100)

      return () => clearTimeout(timeoutId)
    },
  }
}
